
import utils from 'Utils/utils';

/**
* @method q
* @see /src/common/scripts/utils/q.js
*
* @param {String} selector
*
* @return {Array} array with DOM Nodes (document.querySelector('.selector'))
*
* @description
*
* Selects elements using document.querySelectorAll.
*
*	import q from 'Utils/q';
*
*	q('.selector').parent('.selector');
*	q('.selector').child('.selector');
*	q('.selector').addClass('classname');
*	q('.selector').removeClass('classname');
*	q('.selector').html('string');
*	q('.selector').prepend('string');
*	q('.selector').remove();
*	q('.selector').outerHeight(); // Get element height including margins. Defaults to 0.
*	q('.selector').setAttr('attribute', value);
*	q('.selector').removeAttr('attribute');
*	q('.selector').getAttr('attribute'); // Defaults to empty string.
*	q('.selector').addEvent('event', callback);
*	q('.selector').removeEvent('event', callback);
*
*	q('.selector').child('.selector').forEach(node => {
*
*		if (node.classList.contains('classname')) {
*
*			node.classList.add('classname');
*
*		}
*
*	});
*/

class Q extends Array {

	constructor (items) {

		super( ...items );

	}

	parent (selector) {

		const parents = [];

		this.forEach(node => {

			parents.push(node.closest(selector));

		});

		return new Q(parents);

	}

	child (selector) {

		const children = [];

		this.forEach(node => {

			children.push(node.querySelectorAll(selector));

		});

		if (children.length) {

			return new Q( ...children );

		} else {

			return new Q(children);

		}

	}

	index (nodeOrNumber) {

		if (utils.isNumber(nodeOrNumber)) {

			return this[nodeOrNumber];

		} else if (utils.isDOMNode(nodeOrNumber)) {

			return getNodeByIndex(this, nodeOrNumber);

		}

		function getNodeByIndex (self, nodeOrNumber) {

			for (let index = 0; index < self.length; index++) {

				if (self[index] === nodeOrNumber) {

					return index;

				}

			}

		}

	}

	addClass (classNames) {

		this.forEach(node => {

			node.classList.add(classNames);

		});

		return this;

	}

	removeClass (classNames) {

		this.forEach(node => {

			node.classList.remove(classNames);

		});

		return this;

	}

	html (html) {

		this.forEach(node => {

			node.innerHTML = html;

		});

		return this;

	}

	prepend (html) {

		this.forEach(node => {

			node.innerHTML = html + node.innerHTML;

		});

		return this;

	}

	remove () {

		this.forEach(node => {

			node.parentNode.removeChild(node);

		});

		return this;

	}

	outerHeight () {

		let returnValue = 0;

		if (this[0]) {

			const style = getComputedStyle(this[0]);

			returnValue += this[0].offsetHeight + parseInt(style.marginTop) + parseInt(style.marginBottom);

		}

		return returnValue;

	}

	setAttr (attribute, value) {

		this.forEach(node => {

			node.setAttribute(attribute, value);

		});

	}

	removeAttr (attribute) {

		this.forEach(node => {

			node.removeAttribute(attribute);

		});

	}

	getAttr (attribute) {

		let returnValue = '';

		if (this[0]) {

			returnValue = this[0].getAttribute(attribute);

		}

		return returnValue;

	}

	addEvent (eventName, cb) {

		this.forEach(node => {

			node.addEventListener(eventName, cb, false);

		});

		return this;

	}

	removeEvent (eventName, cb) {

		this.forEach(node => {

			node.removeEventListener(eventName, cb);

		});

		return this;

	}

}

export default (selector) => {

	if (utils.isNotEmptyString(selector)) {

		return new Q(document.querySelectorAll(selector));

	} else {

		return new Q([]);

	}

};
